import { useState, useEffect } from 'react';
import { Typography } from '@material-ui/core';
import parse from 'html-react-parser';
import Skeleton from '@material-ui/lab/Skeleton';

const VisiMisi = ({ isId }: any) => {
  const [visiState, setVisiState] = useState<any>(null);
  const [misiState, setMisiState] = useState<any>(null);
  const [loadingState, setLoadingState] = useState(true);

  const getData = async () => {
    try {
      const resVisi = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/content/title/Visi`
      );
      const resMisi = await fetch(
        `${process.env.REACT_APP_URL}/api/jlp/content/title/Misi`
      );
      const resVisiJson = await resVisi.json();
      const resMisiJson = await resMisi.json();
      setVisiState(resVisiJson.data);
      setMisiState(resMisiJson.data);
      setLoadingState(false);
    } catch (err: any) {
      console.log(err.message);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          marginBottom: '7rem',
          padding: '0 16px',
        }}
      >
        <Typography>
          {isId ? 'Tentang Kami' : 'About Us'}
          &nbsp; &gt; &nbsp;{' '}
          <span style={{ color: '#e3232a' }}>
            {isId ? 'Visi dan Misi' : 'Vision and Mission'}
          </span>
        </Typography>
      </div>

      <div
        style={{
          backgroundColor: '#f0f0f0',
          padding: '60px 16px',
          marginBottom: 64,
        }}
      >
        <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative' }}>
          <div
            style={{
              backgroundColor: '#e3232a',
              display: 'inline-block',
              padding: '8px 4em',
              borderRadius: 24,
              position: 'absolute',
              left: 0,
              top: -90,
            }}
          >
            {loadingState ? (
              <Skeleton variant='rect' height={42} width={105} />
            ) : (
              <Typography style={{ color: '#fff' }} variant='h4'>
                {isId ? visiState.title_id : visiState.title_en}
              </Typography>
            )}
          </div>
          <div id='content' style={{ maxWidth: 750 }}>
            {loadingState ? (
              <>
                <Skeleton variant='text' />
                <Skeleton variant='text' />
                <Skeleton variant='text' />
              </>
            ) : isId ? (
              parse(visiState.content_id)
            ) : (
              parse(visiState.content_en)
            )}
          </div>
        </div>
      </div>

      <div
        style={{
          backgroundColor: '#f0f0f0',
          padding: '60px 16px',
          marginBottom: 64,
        }}
      >
        <div style={{ maxWidth: 1280, margin: '0 auto', position: 'relative' }}>
          <div
            style={{
              backgroundColor: '#e3232a',
              display: 'inline-block',
              padding: '8px 4em',
              borderRadius: 24,
              position: 'absolute',
              left: 0,
              top: -90,
            }}
          >
            {loadingState ? (
              <Skeleton variant='rect' height={42} width={105} />
            ) : (
              <Typography style={{ color: '#fff' }} variant='h4'>
                {isId ? misiState.title_id : misiState.title_en}
              </Typography>
            )}
          </div>
          <div id='content' style={{ maxWidth: 750 }}>
            {loadingState ? (
              <>
                <Skeleton variant='text' />
                <Skeleton variant='text' />
                <Skeleton variant='text' />
                <Skeleton variant='text' />
                <Skeleton variant='text' />
              </>
            ) : (
              parse(isId ? misiState.content_id : misiState.content_en)
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default VisiMisi;
